// Adapted from shadcn/ui (MIT). See ../../THIRD_PARTY.md for provenance and local changes.
import type * as React from "react";
import { cn } from "cn";

export const labelStyles =
  "flex items-center gap-2 text-(length:--text-label) leading-(--text-label--line-height) font-medium text-body-foreground select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50";

function Label({ className, htmlFor, ...props }: React.ComponentProps<"label">) {
  return (
    <label data-slot="label" htmlFor={htmlFor} className={cn(labelStyles, className)} {...props} />
  );
}

export { Label };
